<template>
  <div v-if="show_full_screen_loader" class="full-screen-loader">
    <div class="full-screen-loader-inner">
      <h1 v-if="loading_msg != null" v-html="loading_msg"></h1>
      <h1 v-else>Chargement en cours</h1>
    </div>
  </div>
</template>

<script>
import {mapState} from "pinia";
import {useLoaderStore} from "@/stores/loader-store";

export default {
  name: "FullScreenLoader",
  computed: {
    ...mapState(useLoaderStore, ["show_full_screen_loader", "loading_msg"])
  }
}
</script>

<style scoped>
.full-screen-loader
{
  position: absolute;
  z-index:1000000;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255,255,255,128);
}

.full-screen-loader-inner
{
  width: fit-content;
  margin: calc(40vh - 20px) auto auto;
}

</style>